import React from 'react';
import classnames from 'classnames';
import * as html from '../../util/html';
import NoticeCmp from './iconComponent/noticeCmp';
import ErrorCmp from './iconComponent/errorCmp';
import SuccessCmp from './iconComponent/successCmp';
import WarningCmp from './iconComponent/warningCmp';
import './helperTip.scss';

const HelperTip = props => {
  const { promptType = 'notice', tipInfo = '' } = props;
  let typeclass, iconCmp;
  const types = {
    'error': ['tip-error', <ErrorCmp className='helper-tip-svg' />],
    'notice': ['tip-notc', <NoticeCmp className='helper-tip-svg' />],
    'success': ['tip-suc', <SuccessCmp className='helper-tip-svg' />],
    'warning': ['tip-warn', <WarningCmp className='helper-tip-svg' />]
  };
  typeclass = types[promptType] && types[promptType][0] || 'tip-notc';
  iconCmp = types[promptType] && types[promptType][1] || <NoticeCmp className='helper-tip-svg' />;
  if (!tipInfo) return null;
  return (
    <div className={classnames('form-helper-tip', typeclass)}>
      <span className='help-tip-icon'>{iconCmp}</span>
      <pre className='tip-info'>{html.decode(tipInfo)}</pre>
    </div>
  );
};
export default HelperTip;



// WEBPACK FOOTER //
// ./src/components/Form/FormHelper/HelperTip.js